<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMinus } from '@fortawesome/pro-solid-svg-icons';

library.add(faMinus);

const levels = [{
  class: 'has-text-grey-light',
}, {
  class: 'has-text-grey-light',
}, {
  class: 'has-text-grey-light',
}, {
  class: 'has-text-grey-light',
}, {
  class: 'has-text-grey-light',
}];

export default {
  props: {
    // pass in matchStatus object for transactions
    matchStatus: Object,
    // pass in batchStatus string for batches
    batchStatus: String,
  },
  data() {
    return {
      matchStatusSummary: null,
    };
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    // batches
    batchStatusMessage() {
      if (this.batchStatus === 'LOADED') {
        return 'Pending: Request Loaded';
      }
      if (this.batchStatus === 'QUEUED') {
        return 'Pending: Request Queued';
      }
      if (this.batchStatus === 'RUNNING') {
        return 'Pending: In Progress';
      }
      if (this.batchStatus === 'RESTARTING') {
        return 'Pending: Restarting';
      }
      if (this.batchStatus === 'ERRORED' || this.batchStatus === 'ERRORED_VALIDATION') {
        return 'Completed: Errors';
      }
      if (this.batchStatus === 'COMPLETED_WITH_PENDING') {
        return `Pending: ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es)`;
      }
      if (this.batchStatus === 'COMPLETED') {
        return 'Completed';
      }

      if (this.batchStatus === 'VALIDATION_IN_PROGRESS') {
        return 'Pending: Validation In Progress';
      }

      if (this.batchStatus === 'VALIDATION_COMPLETE') {
        return 'Pending: Validation Completed';
      }
      
      if (this.batchStatus === 'VALIDATION_CANCELED') {
        return 'Completed: Validation Canceled';
      }
      return null;
    },
    matchStatusMessage() {
      if (this.completedLevels === 5) {
        return 'Completed';
      }
      if (this.completedLevels === 4) {
        return `Pending: ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es)`;
      }
      if (this.completedLevels === 3) {
        return 'Pending: Errors';
      }
      if (this.completedLevels === 2) {
        return 'Pending: In Progress';
      }
      return null;
    },
    completedLevels() {
      if (this.batchStatus) {
        if (this.batchStatus === 'LOADED') {
          return 1;
        }
        if (this.batchStatus === 'QUEUED') {
          return 2;
        }
        if (this.batchStatus === 'RUNNING' || this.batchStatus === 'ERRORED' || this.batchStatus === 'ERRORED_VALIDATION' || this.batchStatus === 'RESTARTING') {
          return 3;
        }
        if (this.batchStatus === 'COMPLETED_WITH_PENDING') {
          return 4;
        }
        if (this.batchStatus === 'COMPLETED') {
          return 5;
        }
        return 0;
      }

      const { code } = this.matchStatus;

      if (['4', '1', '13', '14', '15', '17', '16', '90'].includes(code)) {
        return 5;
      }
      if (['2'].includes(code)) {
        return 4;
      }
      if (['10', '99'].includes(code)) {
        return 3;
      }
      return 2;
    },
    levels() {
      levels.forEach((l, index) => {
        levels[index].class = (index < this.completedLevels) ? 'has-text-success' : 'has-text-grey-light';
      });
      return levels;
    },
  },
};
</script>

<template>
  <div>
    <div v-if="batchStatus" class="is-flex flex-direction--column">
      <div class="is-flex">
        <font-awesome-icon v-for="(level, idx) in levels" class="fa-lg margin-right-icon"
            :key="`level-${idx}`" :class="level.class" :icon="['fas', 'minus']"/>
      </div>
      <div class="has-text-weight-bold">
        {{ batchStatusMessage }}
      </div>
    </div>
    <div v-if="matchStatus" class="is-flex flex-direction--column">
      <div class="is-flex">
        <font-awesome-icon v-for="(level, idx) in levels" class="fa-lg margin-right-icon"
            :key="`level-${idx}`" :class="level.class" :icon="['fas', 'minus']"/>
      </div>
      <div class="has-text-weight-bold">
        {{ matchStatusMessage }}
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  .margin-right-icon
    margin-right: 2px
</style>
